export const ADMIN_USER_KEY  = 'kiosk_admin_user';